import { createContext, Fragment, useContext, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { setCurrentLang } from "@/i18n";

const MASTER = process.env.REACT_APP_MASTER_ADMIN_USERNAME?.toLowerCase();
const LanguageContext = createContext(null);

export const isMasterAdmin = (u) => !!MASTER && u?.role === "admin" && u?.username?.toLowerCase() === MASTER;

export const LanguageProvider = ({ children }) => {
  const { user } = useAuth();
  const [, rerender] = useState(0);
  const canSwitch = isMasterAdmin(user);
  const storageKey = user ? `l4c_lang_${user.id}` : null;
  const lang = canSwitch && localStorage.getItem(storageKey) === "pt" ? "pt" : "en";
  setCurrentLang(lang);

  const setLang = (next) => {
    if (!canSwitch) return;
    localStorage.setItem(storageKey, next);
    rerender((n) => n + 1);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, canSwitch }}>
      <Fragment key={lang}>{children}</Fragment>
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
